<template>
    <elecBoardHeat></elecBoardHeat>
  </template>
    
  <script>
  import elecBoardHeat from "@/components/elecBoard/elecBoardHeat";
  export default {
    components: {
      elecBoardHeat,
    },
    setup() {},
  };
  </script>
    
  <style lang="scss"></style>
    